import axios from "axios";
import url from "../config/urlServiceConfig";

const kpiDashboardAPI = {
  getDataByStrategyId: (id) => axios.get(`${url.kpiDashboard}/${id}`),
  getDataByPerspectiveId: (id, params) =>
    axios.get(`${url.kpiDashboard}/StrategicObjectives/${id}`, { params }),
  getDataStrategicObjectiveId: (id) =>
    axios.get(`${url.kpiDashboard}/StrategicObjectivesDetails/${id}`),
};

export default kpiDashboardAPI;
